/* global css */
import React from 'react';
import cx from 'classnames';
import { cssInJS } from '../../utils/styles';

interface Props {
  className?: string,
  required?: boolean
}

const RequiredIndicator: React.FC<Props> = ({
  className = '',
  required = false,
}: Props) => {
  // @ts-ignore
  const classes = css(styles.container, !required && styles.hidden);

  return (
    <div className={cx(classes, className)}>*</div>
  );
};

const styles = cssInJS({
  container: {
    visibility: 'visible',
    width: '2%',
    color: 'red',
    fontWeight: 'bold',
    paddingTop: 13,
  },
  hidden: {
    // @ts-ignore
    visibility: 'hidden !important',
  },
});

export default RequiredIndicator;
